<template>
    <div class="center">
        <div class="container">
            <div class="nav">
                <div
                    class="nav-item"
                    v-for="(nav, index) in navList"
                    :class="{active: $route.path === nav.path}"
                    :key="index"
                >
                    <router-link :to="nav.path">{{nav.name}}</router-link>
                </div>
            </div>
            <div class="router">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'center',
    data() {
        return {
            navList: [
                {
                    name: '我的订单',
                    path: '/center/order',
                },
                {
                    name: '我的账户余额',
                    path: '/center/prepay',
                },
                {
                    name: '我的代金券',
                    path: '/center/voucher',
                },
                {
                    name: '我的积分',
                    path: '/center/score',
                },
                {
                    name: '我的地址',
                    path: '/center/address',
                },
                {
                    name: '我的收票地址',
                    path: '/center/invoice-address',
                },
                {
                    name: '我的开票信息',
                    path: '/center/user-invoice',
                },
                {
                    name: '我的运单信息',
                    path: '/center/way-bill',
                },
                {
                    name: '我的信息',
                    path: '/center/userinfo',
                },
                {
                    name: '修改密码',
                    path: '/center/passWord',
                },
            ],
        };
    },
};
</script>

<style lang="less" scoped>
.container {
    display: flex;
    justify-content: flex-start;
    padding-top: 35px;
    .nav {
        width: 120px;
        margin-right: 40px;
        background:#ffffff;
        padding-top:20px;
        height: 430px;
        .nav-item {
            height: 40px;
            line-height: 40px;
            font-size: 14px;
            padding: 0 10px;
            a {
                color: #575757;
                text-decoration: none;
            }
        }
        .active {
          /*  background-image: linear-gradient(90deg, #6db231 0%, #37923a 100%);*/
            a {
                color: #1eb523;
            }
        }
    }
    .router {
        background:#ffffff;
        padding: 20px;
        flex: 1;
    }
}
</style>